import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Careers from "./Careers";
import ContactUs from "./ContactUs";
import Catalogue from "./Catalogue";
import AboutUs from "./AboutUs";
import Services from "./Services";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Garments from "./Garments";
import GarmentView from "./GarmentView";
import FabricCatalogue from "./FabricCatalogue";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";

// Fabrics page start
import FabricsPique from "./components/FabricsPage/Fabrics_Pique";
import FabricsInterlock from "./components/FabricsPage/Fabrics_Interlock";
import FabricsSingleJersey from "./components/FabricsPage/Fabrics_SingleJersey";
import FabricsJacquard from "./components/FabricsPage/Fabrics_Jacquard";
import FabricsLoopKnit from "./components/FabricsPage/Fabrics_LoopKnit";
// import FabricsTerry from "./components/FabricsPage/Fabrics_Terry";
import FabricsFleece from "./components/FabricsPage/Fabrics_Fleece";
import FabricsRibKnit from "./components/FabricsPage/Fabrics_RibKnit";
import FabricsVelour from "./components/FabricsPage/Fabrics_Velour";
import FabricsPointelle from "./components/FabricsPage/Fabrics_Pointelle";
import FabricsTieDye from "./components/FabricsPage/Fabrics_TieDye";
import FabricsWaffle from "./components/FabricsPage/Fabrics_Waffle";
import FabricsSlubKnit from "./components/FabricsPage/Fabrics_SlubKnit";
import FabricsOttoman from "./components/FabricsPage/Fabrics_Ottoman";
import FabricsBirdsEye from "./components/FabricsPage/Fabrics_BirdsEye";
import FabricsPopcorn from "./components/FabricsPage/Fabrics_Popcorn";
import FabricsStriper from "./components/FabricsPage/Fabrics_Striper";
import FabricsNeedleDrop from "./components/FabricsPage/Fabrics_NeedleDrop";
import FabricsMelangeFabrics from "./components/FabricsPage/Fabrics_MelangeFabrics";

// Fabrics page end

// Garment page start
import TShirt from "./components/GarmentsPage/TShirt";
import Hoodie from "./components/GarmentsPage/Hoodie";
import Sweatshirts from "./components/GarmentsPage/Sweatshirts";
import SweatPants from "./components/GarmentsPage/SweatPants";
import Leggings from "./components/GarmentsPage/Leggings";
import Joggers from "./components/GarmentsPage/Joggers";
import KidsTee from "./components/GarmentsPage/KidsTee";
import Rompers from "./components/GarmentsPage/Rompers";
import Onesizes from "./components/GarmentsPage/Onesizes";
import Bibs from "./components/GarmentsPage/Bibs";
import Pyjamas from "./components/GarmentsPage/Pyjamas";

// Garment page end

import FabricCalculator from "./components/FabricCalculator";

import FabricProgram from "./components/FabricProgram";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Careers" element={<Careers />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/Services" element={<Services />} />
      <Route path="/AboutUs" element={<AboutUs />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />

      <Route path="/Catalogue" element={<Catalogue />} />
      <Route path="/Garments" element={<Garments />} />
      {/* For Fabric and Garment view page components reference only start */}
      <Route path="/GarmentView" element={<GarmentView />} />
      {/* For Fabric and Garment view page components reference only end */}
      <Route path="/Fabrics" element={<FabricCatalogue />} />

      {/* Fabrics router start */}
      <Route path="/Fabrics/Pique" element={<FabricsPique />} />
      <Route path="/Fabrics/Interlock" element={<FabricsInterlock />} />
      <Route path="/Fabrics/SingleJersey" element={<FabricsSingleJersey />} />
      <Route path="/Fabrics/Jacquard" element={<FabricsJacquard />} />
      <Route path="/Fabrics/LoopKnit" element={<FabricsLoopKnit />} />
      {/* <Route path="/Fabrics/Terry" element={<FabricsTerry />} /> */}
      <Route path="/Fabrics/FleeceKnit" element={<FabricsFleece />} />
      <Route path="/Fabrics/RibKnit" element={<FabricsRibKnit />} />
      <Route path="/Fabrics/Velour" element={<FabricsVelour />} />
      <Route path="/Fabrics/Pointelle" element={<FabricsPointelle />} />
      <Route path="/Fabrics/TieDye" element={<FabricsTieDye />} />
      <Route path="/Fabrics/Waffle" element={<FabricsWaffle />} />
      <Route path="/Fabrics/SlubKnit" element={<FabricsSlubKnit />} />
      <Route path="/Fabrics/Ottoman" element={<FabricsOttoman />} />
      <Route path="/Fabrics/BirdsEye" element={<FabricsBirdsEye />} />
      <Route path="/Fabrics/Popcorn" element={<FabricsPopcorn />} />
      <Route path="/Fabrics/Striper" element={<FabricsStriper />} />
      <Route path="/Fabrics/NeedleDrop" element={<FabricsNeedleDrop />} />
      <Route path="/Fabrics/Melange" element={<FabricsMelangeFabrics />} />

      {/* Fabrics router end */}

      {/* Garments Router start */}
      <Route path="/Garments/TShirt" element={<TShirt />} />
      <Route path="/Garments/Hoodie" element={<Hoodie />} />
      <Route path="/Garments/Sweatshirts" element={<Sweatshirts />} />
      <Route path="/Garments/SweatPants" element={<SweatPants />} />
      <Route path="/Garments/Leggings" element={<Leggings />} />
      <Route path="/Garments/Joggers" element={<Joggers />} />
      <Route path="/Garments/KidsTee" element={<KidsTee />} />
      <Route path="/Garments/Rompers" element={<Rompers />} />
      <Route path="/Garments/Onesizes" element={<Onesizes />} />
      <Route path="/Garments/Bibs" element={<Bibs />} />
      <Route path="/Garments/Pyjamas" element={<Pyjamas />} />
      {/* Garments Router end */}

      {/* Catch-all route: Redirect to home if no other route matches */}
      <Route path="/FabricCalculator" element={<FabricCalculator />} />

      <Route path="/FabricProgram" element={<FabricProgram />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
